/*
 * @Author: yeyimei
 * @Date: 2023-08-25 11:43:20
 * @LastEditTime: 2023-08-28 10:43:18
 * @LastEditors: yeyimei
 * @Description:
 * @FilePath: \cardlan-h5-qrcode\src\utils\travel.js
 */
import request from "./method-type.js"
import axios from "./http"

//同程旅行访问活动页统计
export const submitTcActivityAPi = (data) => {
  return request.post(`hm/request/total/tc/activity`, data)
}

//同程旅行访问URL统计
export const submitTcUrlAPi = (data) => {
  return request.post(`hm/request/total/tc/url`, data)
}

//获取同程配置列表
export const getConfigTcListAPi = () => {
  return request.get(`hm/url/config/tc/list`)
}

//获取同程使用说明
export const getConfigTcExplainAPi = () => {
  return request.get(`hm/url/config/tc/explain`)
}

//同程旅行票务访问URL跳转统计
export const getTotalTcTicketAPi = (data) => {
  return request.post(`hm/request/total/tc/ticket`, data)
}
